import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { reducers } from './store/reducers';
import { EffectsModule } from '@ngrx/effects';
import { TransactionsEffects } from './store/effects/transactions.effects';
import { TransactionsRoutingModule } from './transactions-routing.module';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    imports: [
        CommonModule,
        TransactionsRoutingModule,
        StoreModule.forFeature('iRoyal-transactions', reducers),
        EffectsModule.forFeature([TransactionsEffects]),
    ],
    providers: [
        NgbDropdown,
    ]
})
export class TransactionsModule {}
